<template>
  <div>
    <div class="register-domain columns">
      <div class="column">
        <div class="is-size-2 mb">
          {{ $t('register_domain.title') }}
        </div>
        <div class="is-size-5">
          {{ $t('register_domain.header') }}
          <!-- {{ $t('domains.title') }} -->
          <router-link
            :to="{ name: 'DomainRegistration' }"
            class="button is-primary is-broad is-uppercase is-large"
          >
            {{ $t('register_domain.button') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RegisterNewDomain'
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.register-domain {
  color: #363636;

  .button {
    margin-left: 15px;
    vertical-align: middle;
    @media(max-width: 768px) {
      margin-left: 0px;
    }
  }

  .mb {
    margin-bottom: 10px;
  }
}
</style>
